import moment from 'moment';
import Cookies from 'universal-cookie';

const calculateBreakHelpPartner = (startTime) => {
  if (!startTime) return 0;

  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const target = moment.tz(startTime, timezone);

  const now = moment.tz(timezone);

  const diff = now.diff(target, 'seconds');

  return diff;
};

export default calculateBreakHelpPartner;
